<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [closable]="false"
  [blockScroll]="true"
  appendTo="body"
  styleClass="appointment-details-drawer"
>
  <ng-template #header>
    <div class="flex align-items-start justify-content-between w-full">
      <div class="flex flex-column gap-1">
        <div class="text-lg-semibold text-gray-900">Detalji</div>
        <div class="text-sm-regular text-gray-600">Pogledaj detalje termina</div>
      </div>
      <div class="flex justify-content-center align-items-center cursor-pointer close-btn" (click)="close()">
        <app-x-close stroke="#ADB0B8" width="12" height="12"></app-x-close>
      </div>
    </div>
  </ng-template>

  <app-appointment-details-content
    [appointmentId]="currentId"
    (onCancel)="handleCancel($event)"
    (onRescheduled)="handleRescheduled($event)"
    (onMarkedNoShow)="handleMarkedNoShow($event)"
  ></app-appointment-details-content>
</p-drawer>
